var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'button-group': _vm.group }},[_c('button',{class:[
      'button',
      _vm.size ? 'button-' + _vm.size : '',
      _vm.rounded ? 'button-rounded' : '',
      _vm.icon ? 'button-icon' : '',
      _vm.variant ? 'btn-' + _vm.variant : '',
      !_vm.variant && _vm.color ? 'text-' + _vm.color : '',
      !_vm.variant && _vm.background ? 'bg-' + _vm.background : '',
      !_vm.variant && _vm.colorHover ? 'hover:text-' + _vm.colorHover : '',
      !_vm.variant && _vm.backgroundHover ? 'hover:bg-' + _vm.backgroundHover : '',
      _vm.shadown ? 'button-shadown' : '',
      _vm.block ? 'button-block' : '' ],style:(_vm.customStyle),attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.action}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }